import { render, staticRenderFns } from "./MensagemErro.vue?vue&type=template&id=4ed14de7"
import script from "./MensagemErro.vue?vue&type=script&lang=ts"
export * from "./MensagemErro.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports